// extracted by mini-css-extract-plugin
export var backgroundImage = "layout-module--backgroundImage--tlcdY";
export var copyright = "layout-module--copyright--AErfB";